<template>
  <div class="relative">
    <button v-if="areaLevel === 'school'" class="mb-2 lg:mb-0 bg-white hover:bg-grey-lightest text-black text-xs font-bold py-2 px-3 rounded flex items-center mr-2" @mouseover="isShowSchoolLevelSelection = true">
      <v-icon scale="1.2" class="self-center text-button-icon" name="layer-group" />
    </button>
    <div class="mb-2 lg:mb-0 bg-white py-2 px-3 w-48 rounded border absolute pin-b pin-l flex flex-col z-1010" v-if="isShowSchoolLevelSelection" @mouseleave="isShowSchoolLevelSelection = false">
      <div class="flex flex-row">
        <div class="flex-1 flex-col">
          <div class="text-grey-dark text-sm">Negeri</div>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowAllNegeri" @click="showAllNegeri">
            <span class="text-sm">
              Semua
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowSDNegeri" @click="updateNegeriAllStatus('SD')">
            <span class="text-sm">
              SD
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowSMPNegeri" @click="updateNegeriAllStatus('SMP')">
            <span class="text-sm">
              SMP
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowSMANegeri" @click="updateNegeriAllStatus('SMA')">
            <span class="text-sm">
              SMA
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowSMKNegeri" @click="updateNegeriAllStatus('SMK')">
            <span class="text-sm">
              SMK
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowPKBMNegeri" @click="updateNegeriAllStatus('PKBM')">
            <span class="text-sm">
              PKBM
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowOthersNegeri" @click="updateNegeriAllStatus('Others')">
            <span class="text-sm">
              Lainnya
            </span>
          </label>
        </div>
        <div class="flex-1 flex-col">
          <div class="text-grey-dark text-sm">Swasta</div>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowAllSwasta" @click="showAllSwasta">
            <span class="text-sm">
              Semua
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowSDSwasta" @click="updateSwastaAllStatus('SD')">
            <span class="text-sm">
              SD
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowSMPSwasta" @click="updateSwastaAllStatus('SMP')">
            <span class="text-sm">
              SMP
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowSMASwasta" @click="updateSwastaAllStatus('SMA')">
            <span class="text-sm">
              SMA
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowSMKSwasta" @click="updateSwastaAllStatus('SMK')">
            <span class="text-sm">
              SMK
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowPKBMSwasta" @click="updateSwastaAllStatus('PKBM')">
            <span class="text-sm">
              PKBM
            </span>
          </label>
          <label class="text-black font-bold flex items-center">
            <input class="mr-1" type="checkbox" :checked="isShowOthersSwasta" @click="updateSwastaAllStatus('Others')">
            <span class="text-sm">
              Lainnya
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'school-filter',
  props: {
    areaLevel: String,
    showAllNegeri: Function,
    updateNegeriAllStatus: Function,
    showAllSwasta: Function,
    updateSwastaAllStatus: Function,
    isShowAllNegeri: Boolean,
    isShowSDNegeri: Boolean,
    isShowSMPNegeri: Boolean,
    isShowSMANegeri: Boolean,
    isShowSMKNegeri: Boolean,
    isShowPKBMNegeri: Boolean,
    isShowOthersNegeri: Boolean,
    isShowAllSwasta: Boolean,
    isShowSDSwasta: Boolean,
    isShowSMPSwasta: Boolean,
    isShowSMASwasta: Boolean,
    isShowSMKSwasta: Boolean,
    isShowPKBMSwasta: Boolean,
    isShowOthersSwasta: Boolean
  },
  data () {
    return {
      isShowSchoolLevelSelection: false
    }
  }
}
</script>
